import axios from "axios";
import React, {useEffect, useState} from "react";
import {useParams} from 'react-router-dom';
import {baseUrl, userLocation} from '../Univ.js'
function GrnInvoice(props) {
    const {grn_id} = useParams();
    const [opbillData, setopbillData] = useState([]);
    const [hospData, setHospData] = useState([]);
    const [distData, setDistData] = useState([]);
    const [viewPharmData, setViewPharmData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                // Get GRN data
                const grnResponse = await axios.get(
                    `${baseUrl}grn-invoice/${grn_id}`
                );
                setopbillData(grnResponse.data);
                // Get distributor
                if (grnResponse.data?.dist?.id) {
                    const distResponse = await axios.get(
                        `${baseUrl}edit-distributor/${grnResponse.data.dist.id}`
                    );
                    setDistData(distResponse.data);
                }
                // Get hospital
                const hospitalResponse = await axios.get(
                    `${baseUrl}view-hospital/${userLocation}/`
                );
                console.log("Hospital API Response:", hospitalResponse.data);
                if (Array.isArray(hospitalResponse.data)) {
                    setHospData(hospitalResponse.data);
                } else {
                    setHospData([]);
                }
            } catch (error) {
                console.error("GRN Invoice Error:", error);
                setHospData([]);
            }
        };
        fetchData();
    }, [grn_id]);
    const handlePrint = () => {
        const printContents = document.getElementById('invoice-print').innerHTML;
        const originalContents = document.body.innerHTML;
        document.body.innerHTML = printContents;
        window.print();
        setTimeout(() => {
            window.location.reload();
        }, 1000);
        document.body.innerHTML = originalContents;
    };
    return (
        <section>
            <div>
                {opbillData.map((row, index) =>
                    <div id="invoice-print">
                        <div
    style={{
        width: "100%",
        margin: 0,
        padding: 0,
        overflow: "hidden",
        lineHeight: 0
    }}
>
    {hospData.map((hospital) => (
        <img
            key={hospital.id}
            src={hospital.logo}
            alt="Hospital Header"
            style={{
                width: "100%",
                height: "110px",
                display: "block",
                margin: 0,
                padding: 0,
                border: "none",
                objectFit: "fill"
            }}
        />
    ))}
</div>

<div
    style={{
        width: "100%",
        margin: "8px 0 0 0",
        padding: "8px 12px",
        boxSizing: "border-box",
        borderTop: "1px solid #333",
        borderBottom: "1px solid #333",
        fontSize: "14px",
        lineHeight: "1.5"
    }}
>
    <div
        style={{
            display: "flex",
            width: "100%",
            alignItems: "flex-start"
        }}
    >
        <div
            style={{
                width: "55%",
                paddingRight: "15px",
                boxSizing: "border-box",
                borderRight: "1px solid #999"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>Order To</strong>
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Distributor :</strong>&nbsp;
                {row.dist.name} - {row.dist.person}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Contact :</strong>&nbsp;
                {row.dist.mobile}
            </div>

            <div>
                <strong>Address :</strong>&nbsp;
                {row.dist.address}
            </div>
        </div>

        <div
            style={{
                width: "45%",
                paddingLeft: "15px",
                boxSizing: "border-box"
            }}
        >
            <div style={{ marginBottom: "3px" }}>
                <strong>GRN No #:</strong>&nbsp;
                {row.grn_no}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>GRN Date :</strong>&nbsp;
                {row.grn_date}&nbsp;
                {row.add_time?.split('.')[0]}
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>
                    {row.type
                        ? row.type.charAt(0).toUpperCase() +
                          row.type.slice(1)
                        : ""} Receipt
                </strong>
            </div>

            <div style={{ marginBottom: "3px" }}>
                <strong>Invoice No #:</strong>&nbsp;
                {row.invoice}
            </div>

            <div>
                <strong>Invoice Date :</strong>&nbsp;
                {row.inv_date}
            </div>
        </div>
    </div>
</div>
                        <div className="table-responsive">
                            <table border="2" rules="rows" cellpadding="3" className=" mt-4" width="100%">
                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th align="left">S.No</th>
                                    <th align="left">Product</th>
                                    <th align="left">Batch No</th>
                                    <th align="left">Expiry Date</th>
                                    <th align="left">Packs</th>
                                    <th align="left">Qty</th>
                                    <th align="left">F Qty</th>
                                    <th align="left">Total Qty</th>
                                    <th align="left">MRP</th>
                                    <th align="left">Purchase</th>
                                    <th align="left">SGST %</th>
                                    <th align="left">CGST %</th>
                                    <th align="left">Net Amount</th>
                                </tr>
                                </thead>
                                <tbody>
                                {row.product.split(',').map((test, subIndex) => {
                                    return (
                                        <tr key={`${index}-${subIndex}`}
                                            style={{border: "1px solid", borderColor: "#2194d9"}}>
                                            <td>{index + subIndex + 1}</td>
                                            <td><b>{row.product.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.batch.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.expiry.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.pack.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.qty.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.fqty.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.totqty.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.mrp.split(',')[subIndex].trim()}
                                            </b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{row.pprice.split(',')[subIndex].trim()}
                                            </b></td>
                                            <td><b>{row.sgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b>{row.cgst.split(',')[subIndex].trim()}</b></td>
                                            <td><b><i className="fa fa-inr"
                                                      aria-hidden="true"></i>&nbsp;{parseFloat(row.netamount.split(',')[subIndex].trim()).toFixed(2)}
                                            </b></td>
                                        </tr>
                                    );
                                })}
                                </tbody>
                                <tfoot>
                                <tr>
                                    <td colSpan="5"></td>
                                    <td><b>GRN <br/>Amount</b></td>
                                    <td><b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.grnamount}</b>
                                    </td>
                                    <td><b>Invoice <br/>Amount</b></td>
                                    <td><b><i className="fa fa-inr" aria-hidden="true"></i>&nbsp;{row.invamount}</b>
                                    </td>
                                </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>
                )}
                <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
                    <button
                        style={{padding: '5px 20px', borderRadius: '10px', backgroundColor: '#007bff', color: '#fff'}}
                        onClick={handlePrint}
                    >
                        Print
                    </button>
                </div>
            </div>
        </section>
    );
}
export default GrnInvoice;